module.exports = __webpack_public_path__ + "img/f70853b.png";